
import sliderCom from "@/components/SliderCom.vue";
import box from "@/components/BoxCom.vue";
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import dialogCom from "@/components/ModelCom.vue";
import AddrCom from "@/components/AddrCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import { StoreTypes } from "@/assets/js/Types";
import delCom from "@/components/DelDataCom.vue";
import Utils from "@/assets/js/Utils";
import { util } from "vue/types/umd";
import mapCom from "@/components/MapCom.vue";
export default Vue.extend({
  components: { action, dialogCom, AddrCom, delCom, sliderCom, box, mapCom },
  data() {
    return {
      pointerForm: {
        sid: "",
        pointer: {
          lat: 0,
          lng: 0,
          name: "",
        },
      },
      delUrl: Urls.DelVideoDevice,
      total: 0,
      pageSize: 20,
      items: [] as any,
      currentPage: 1,
      current: null as any,
      currentSid: null as any,
      title: "",
      form: {
        sid: "" as any,
        lat: 0,
        lng: 0,
        addr: "",
        name: "",
        distance: 0,
      },
      deviceTypes: [] as any,
      fileTitle: "",
      noexcel: false,
      choosedItem: [] as any[],
      urlData: null as any,
      csid: null as any,
      slider: [] as any[],
      map: null as any,
      mapDrawEnable: false as any,
      lines: [] as any[],
      pointerEnable: false,
      mapIconPointer: require("@/assets/img/map/pointer.png"),
    };
  },
  mounted() {
    this.map = this.$refs.mapCom;
    this.urlData = Utils.getActionUrl(this.$route.path);
    this.delUrl = this.urlData.delUrl;
    this.initMap();
    this.getList();
  },
  methods: {
    async dragend(d: any, type: any, data: any) {
      const req = {
        lat: data.lnglat.lat,
        lng: data.lnglat.lng,
        sid: d.sid,
      };
      await HttpUtil.XCHttpPost(Urls.UpdatePointerPosition, req, true, false);
      this.getList();
    },
    devClick(d: any) {
      this.$alert("请确认是否删除该打卡点", "提示", {
        confirmButtonText: "确认",
        callback: (action) => {
          HttpUtil.XCHttpPost(Urls.RemovePointer, d.sid, true, false).then(() => {
            this.getList();
          });
        },
      });
    },

    async onPointerSubmit() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.pointerForm.sid = this.current.sid;
      await HttpUtil.XCHttpPost(Urls.AddPointer, this.pointerForm, true, false);
      this.closePointerDialog();
      this.getList();
    },
    closePointerDialog() {
      const dialog: any = this.$refs.pointerDialog;
      dialog.hiden();
    },
    pointerClick() {
      this.pointerEnable = true;
      this.mapDrawEnable = false;
      this.$alert("在打卡点点击鼠标左键新增打卡点。", "提示", {
        confirmButtonText: "确认",
      });
    },
    initMap() {
      this.map.init(true);
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.sid);
      });
    },
    currentChange(val: any) {
      this.current = val;
    },
    closeDialog() {
      const dialog: any = this.$refs.dialog;
      dialog.hiden();
    },
    opened() {
      setTimeout(() => {
        const addr: any = this.$refs.addr;
        if (!this.current) {
          addr.init(null);
        } else {
          addr.init({
            addr: this.current.addr,
            lat: this.current.lat,
            lng: this.current.lng,
          });
        }
      }, 2000);
    },
    reDraw() {
      this.mapDrawEnable = true;
      this.pointerEnable = false;
      this.lines = [];
      this.map.removePolyLine();
      this.$alert(
        "在地图上沿工作线路依次点击鼠标左键绘制工作线路。最后点击鼠标右键保存路径",
        "提示",
        {
          confirmButtonText: "确认",
        }
      );
    },
    importData() {
      this.fileTitle = "请选择上传摄像头Excel文件";
      this.noexcel = false;
      const upload: any = this.$refs.uploadFile;
      upload.open();
    },
    insert() {
      this.title = "新增设备";
      this.form.sid = null;
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
    async modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.form = this.current;
      this.title = "修改控制器";
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret = await DeviceRequestBill.GetNormalDevice(
        content,
        this.currentPage,
        this.pageSize,
        this.urlData.getListUrl
      );
      this.items = ret.data;
      this.total = ret.total;
      this.getSlider();
    },
    async onSubmit() {
      const addr: any = this.$refs.addr;
      const data: any = addr.getData();
      this.form.addr = data.addr;
      this.form.lat = data.lat;
      this.form.lng = data.lng;
      if (!this.form.sid) {
        await HttpUtil.XCHttpPost(this.urlData.addUrl, this.form, true, false);
      } else {
        await HttpUtil.XCHttpPost(this.urlData.updateUrl, this.form, true, false);
      }
      this.closeDialog();
      this.getList();
    },
    del() {
      const dialog: any = this.$refs.del;
      if (this.choosedItem && this.choosedItem.length == 0) {
        if (!this.current) {
          throw "请选择一条数据";
        }
        this.currentSid = this.current.sid;
        dialog.show();
      } else {
        dialog.show(true);
      }
    },
    async temp() {
      const url = `${Utils.GetBaseUrl()}/templates/VideoTemplte.xlsx`;
      window.open(url);
    },
    async batchdel() {
      await HttpUtil.XCHttpPost(Urls.DelVideoDevices, this.choosedItem, true, false);
      this.getList();
    },
    async AsyncVideoDevice() {
      await HttpUtil.XCHttpPost(Urls.AsyncVideoDevice, "", true, false);
      window.setTimeout(() => {
        this.getList();
      }, 2000);
    },
    change(sid: string) {
      this.currentSid = sid;
      this.current = this.items.filter((x: any) => x.sid == sid)[0];
      this.map.setCenter(this.current.lat, this.current.lng);
      this.map.removePolyLine();
      this.map.clearDevice(6);
      this.lines = [];
      this.lines = JSON.parse(this.current.workLines);
      if (this.lines && this.lines.length > 0) {
        this.drawPolcy(this.lines);
      }
      if (this.current.pointers && this.current.pointers.length > 0) {
        this.current.pointers.forEach((x: any) => {
          this.map.addMarker(
            this.current.pointers,
            this.mapIconPointer,
            { w: 50, h: 65 },
            6
          );
        });
      }
    },
    async mapRightClick() {
      this.mapDrawEnable = false;
      const data = {
        sid: this.current.sid,
        workLines: this.lines,
      };
      await HttpUtil.XCHttpPost(Urls.UpdateWorkLines, data, true, false);
    },
    mapClick(e: any) {
      if (this.mapDrawEnable) {
        this.lines.push({
          lat: e.lnglat.lat,
          lng: e.lnglat.lng,
        });
        if (this.mapDrawEnable) {
          this.drawPolcy(this.lines);
        }
      } else if (this.pointerEnable) {
        this.pointerForm.pointer.lat = e.lnglat.lat;
        this.pointerForm.pointer.lng = e.lnglat.lng;
        this.pointerForm.pointer.name = "";
        const dialog: any = this.$refs.pointerDialog;
        dialog.show();
      }
    },
    drawPolcy(data: any[], moveData?: any) {
      const map: any = this.$refs.mapCom;
      map.drawPolyLine(data, moveData);
    },
    getSlider() {
      this.slider = [];
      this.items.forEach((item: any) => {
        this.slider.push({
          sid: item.sid,
          name: item.name,
        });
      });
      if (this.slider && this.slider.length > 0) {
        this.change(this.slider[0].sid);
        const slider: any = this.$refs.slider;
        slider.setCurrentSid(this.slider[0].sid);
      }
    },
  },
});
